import { Sites } from '@ps/platform-message-framework/common/Sites';
import { FeatureFlag } from '@ps/web-core-enums';
import { useFeature } from '@ps/web-core-store';
import { Translation } from '@ps/web-shared-components';
import { dateDob } from '@ps/web-shared-validators';
import React, { useEffect } from 'react';
import { FormattedDateParts } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';

import type { Dispatch } from '@swf/core/store';
import { select } from '@swf/core/store';
import {
  dateFormatFactory,
  dateParseFactory,
  dateFormat as formatValues,
  getIntlDateFormat
} from '@swf/core/utils/formatting';

import DateInput from '../DateInput/DateInput';

import {
  TXTCLI_Date_of_Birth,
  TXTCLI_Date_of_birth,
  TXTCLI_Please_provide_your_Date_of_Bi_ELL,
  TXTCLI_You_are_under_18X_A_person_und_ELL_1,
  TXTWCL_Check_thatXs_correct_and_try_a_ELL,
  TXTWCL_Check_that_dayX_monthX_and_yea_ELL,
  TXTWCL_SorryX_you_need_to_be_N0_or_ol_ELL
} from './DOB.messages.json';
import { dateWrapper, message, wrapper } from './DOB.scss';

const fieldName = 'dob';
const date = new Date();

interface Props {
  hasBeenShown?: boolean;
}

const DOB: React.FC<Props> = ({ hasBeenShown = true }) => {
  const { cms } = useDispatch<Dispatch>();
  const legalAge = useSelector(select.cms.getLegalAge);
  const blacklistCheck = useFeature(FeatureFlag.BlackListCheck);
  const isAutofocusEnabled = useFeature(FeatureFlag.SwcSignupRmfAutofocus);
  const isSumSubEnabled = useFeature(FeatureFlag.SwcSignupRmfSumSub);
  const isSitePT = useSelector(select.cms.getSiteId) === Sites.POR;
  const isSiteUK = useSelector(select.cms.getSiteId) === Sites.UK;

  useEffect(() => {
    if (!legalAge) cms.fetchWebsite();
  }, [cms, legalAge]);

  return (
    <FormattedDateParts value={date}>
      {(parts) => {
        const dateFormat = getIntlDateFormat(parts, formatValues);

        return (
          <div className={wrapper}>
            <DateInput
              id={fieldName}
              name={fieldName}
              autoComplete="off"
              validators={[
                dateDob(
                  blacklistCheck
                    ? {
                        invalidDateMessage: TXTCLI_Please_provide_your_Date_of_Bi_ELL,
                        legalAgeMessage: TXTCLI_You_are_under_18X_A_person_und_ELL_1
                      }
                    : {
                        invalidDateMessage: TXTWCL_Check_thatXs_correct_and_try_a_ELL,
                        legalAgeMessage: TXTWCL_SorryX_you_need_to_be_N0_or_ol_ELL
                      },
                  legalAge
                )
              ]}
              dateFormat={dateFormat}
              hideFormatInLabel
              label={isSitePT ? TXTCLI_Date_of_birth : TXTCLI_Date_of_Birth}
              className={dateWrapper}
              parse={dateParseFactory(dateFormat)}
              format={dateFormatFactory(dateFormat)}
              autoFocus={(hasBeenShown || isSumSubEnabled) && isAutofocusEnabled}
            />
            {isSiteUK && (
              <div className={message}>
                <Translation {...TXTWCL_Check_that_dayX_monthX_and_yea_ELL} />
              </div>
            )}
          </div>
        );
      }}
    </FormattedDateParts>
  );
};

export default DOB;
